<template>
    <div class="skill-progress">
        <h5 class="title">{{label}}</h5>
        <b-progress :max="max">
            <b-progress-bar :value="value"></b-progress-bar>
        </b-progress>
    </div>
</template>

<script>
export default {
    name: "design-2021-learning-path-category-show-skill-progress-component",
    props: {
        label: {
            type: String,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
        value: {
            type: Number,
            required: true,
        },
    }
}
</script>

<style scoped>

</style>
